<template>
  <div
    v-bind:style="customStyles"
    :class="[
      'loader__container',
      $props.classes,
      { hide: hide }
    ]"
  >
    <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" class="loader__circle">
      <circle class="loader__track" cx="50%" cy="50%" r="190" />
      <circle ref="progress" class="loader__track loader__progress" cx="50%" cy="50%" r="190" />
    </svg>
    <svg class="loader__checkerboard" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
      <path d="M 5 5 L 395 5 L 395 395 L 5 395 Z" class="loader__box"></path>
      <path d="M 200 0 L 400 0 L 400 200 L 200 200 Z" class="loader__square"></path>
      <path d="M 0 400 L 0 200 L 200 200 L 200 400 Z" class="loader__square loader__square--bottom"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "loading-spinner",
  props: {
    size: {
      type: String,
      default: "120"
    },
    position: {
      type: String,
      default: "relative"
    },
    showSpinnerDefault: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    },
    displayText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hide: !this.showSpinnerDefault
    };
  },
  computed: {
    /**
     * Adds custom styles set as props to the spinner
     * @public
     */
    customStyles() {
      return {
        height: this.size + "px",
        width: this.size + "px",
        position: this.position
      };
    }
  },
  methods: {
    hideSpinner(hide) {
      this.$eventBus.$emit("disable-next-back-buttons", !hide);
      this.hide = hide;
    },
  },
  created() {
    this.$eventBus.$on("hide-customs-spinner", this.hideSpinner);
  }
};
</script>